export const en = {
    'relevance-match': 'autotargeting'
};
